import React from "react";
import Quiz from "./Quiz";

function App() {
  return (
    <div>
      <Quiz />
    </div>
  );
}

export default App;
